import { useEffect, useState } from "react";
import {  Progress, Input, Pagination } from "antd";
import { isEmpty, isNil } from "lodash";
import { useSelector, useDispatch } from "react-redux";

import styles from "./tasksPerOwnerV2.module.css";

import { SearchOutlined } from "@ant-design/icons";

import { labelOfCompanyType, labelOfRole } from "../../util/labelOf";
import { setFilteredUsers } from "../../store/forms/actions";

const TasksPerOwnerV2 = ({ users, obligations }) => {
  const organizationOptions = useSelector(state => state.organizations.organizations);
  const organizationId = useSelector(state => state.organizations.organizationId)
  const filteredUsers = useSelector(state => state.forms?.filteredUsers);
  const dispatchito = useDispatch();

  // State for current page and items per page (for pagination)
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3;

  //handle changes
  const onPageChange = page => {
    setCurrentPage(page);
  };

  //local state
  // New state for the search term
  const [searchTerm, setSearchTerm] = useState("");

  const color = ["#00A7B5", "#FF7D1E", "#725798", "#9BD732"];
  const tasksPerUser = (item, obligations) =>
    !isNil(obligations) ?
    obligations.filter(obl => obl.user_id === item._id).length : 0;

  //helper function to get the organization name
  const getOrganizationName = orgId => {
    const organization = organizationOptions?.find(org => org._id === orgId);
    return organization ? organization.customerName : "N/A";
  };

  //helper function to get the organization type
  const getOrganizationType = orgId => {
    const organization = organizationOptions?.find(org => org._id === orgId);
    return organization ? organization.companyType : "N/A";
  };
  useEffect(() => {
    setCurrentPage(1) 
    setSearchTerm() 
  },[organizationId])

  useEffect(() => {
    setCurrentPage(1)
    // Helper function to filter users based on the search term
    const changedFilteredUsers =
    !isEmpty(users) && Array.isArray(users)
      ? searchTerm
        ? users
            ?.filter(
              user =>
                user.role === "assignedUser" ||
                user.role === "corporateComplianceAssessor"
            )
            .filter(
              user =>
                (user.firstName
                  ? user.firstName
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                  : false) ||
                (user.lastName
                  ? user.lastName
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                  : false) ||
                (user.email
                  ? user.email.toLowerCase().includes(searchTerm.toLowerCase())
                  : false)
            )
        : users?.filter(
            user =>
              user.role === "assignedUser" ||
              user.role === "corporateComplianceAssessor"
          )
      : [];

      // console.debug("filteredUsers",changedFilteredUsers)
      dispatchito(setFilteredUsers({users: changedFilteredUsers, flag: searchTerm}))
  },[searchTerm, users, dispatchito])

  const sortedfilteredUsers = filteredUsers?.length ? [...filteredUsers].sort((a, b) => {
    const tasksDifference = tasksPerUser(b, obligations) - tasksPerUser(a, obligations);
    
    if (tasksDifference === 0 && a.role && b.role) {
      // return a.name.localeCompare(b.name); 
      // console.debug("compare:",a.role.localeCompare(b.role));
      if(a.role.localeCompare(b.role) === 0 && a.name && b.name){
        return a.name.localeCompare(b.name); 
      }
      else {
        return a.role.localeCompare(b.role);
      }
    }
        
        return tasksDifference;
      }) : [];

    const currentItems =
    sortedfilteredUsers?.length
      ? sortedfilteredUsers.slice(
          (currentPage - 1) * itemsPerPage,
          currentPage * itemsPerPage
        )
      : [];

  const renderFilteredUsers = currentShownUsers => {
    // const sortedCurrentShownUsers = [...currentShownUsers].sort((a, b) => tasksPerUser(b,obligations) - tasksPerUser(a,obligations));
    return (
      <>
        {currentShownUsers &&
          !currentShownUsers.error &&
          currentShownUsers?.map((item, index) => {
            return (
              <div className="mt-2" key={item.email}>
                <div
                  className="mr-2"
                  style={{
                    textAlign: "left",
                    paddingLeft: "2.5rem",
                    display: "flex"
                  }}
                >
                  <div
                    className="first-part"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "20rem"
                    }}
                  >
                    <div className="first-row">
                      <span
                        style={{ backgroundColor: color[index % 4] }}
                        className="dot"
                      ></span>
                      <span
                        className="owner-span"
                        style={{
                          color: "#333",
                          fontFamily: "Roboto",
                          fontSize: "1rem",
                          fontStyle: "normal",
                          fontWeight: "600",
                          lineHeight: "1rem"
                        }}
                      >
                        {item.firstName}&nbsp;{item.lastName}
                      </span>
                    </div>
                    <div className="second-row">
                      <span
                        style={{
                          paddingLeft: "0.75rem",
                          color: "rgba(51, 51, 51, 0.50)",
                          fontFamily: "Roboto",
                          fontSize: "0.75rem",
                          fontStyle: "normal",
                          fontWeight: "500",
                          lineHeight: "1rem"
                        }}
                      >
                        {/* {item.email} */}
                      </span>
                    </div>
                  </div>
                  <div
                    className="second-part"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      paddingLeft: "1.875rem"
                    }}
                  >
                    <div className="first-row">
                      <span
                        className="owner-span"
                        style={{
                          color: "rgba(51, 51, 51, 0.70)",
                          fontFamily: "Roboto",
                          fontSize: "1rem",
                          fontStyle: "normal",
                          fontWeight: "500",
                          lineHeight: "1rem"
                        }}
                      >
                        {getOrganizationName(item.organization)}
                      </span>
                    </div>
                    <div className="second-row">
                      <span
                        style={{
                          color: "rgba(51, 51, 51, 0.50)",
                          fontFamily: "Roboto",
                          fontSize: "0.75rem",
                          fontStyle: "normal",
                          fontWeight: "500",
                          lineHeight: "1rem"
                        }}
                      >
                        {labelOfRole(item.role)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className={styles["progress-bar-area"]}>
                  <Progress
                    percent={ obligations?.length ?
                      ((tasksPerUser(item, obligations) / obligations?.length) *
                      100) : 0
                    }
                    strokeColor={color[index % 4]}
                    showInfo={false}
                    style={{
                      width: "90%"
                    }}
                    type="line"
                    strokeWidth={1}
                  />
                  <span>{tasksPerUser(item, obligations)}</span>
                </div>
              </div>
            );
          })}
      </>
    );
  };

  return (
    <div id="tasks-per-owner-v2" className={styles["per-owner-container-v2"]}>
      <div className={styles["per-owner-title-area-v2"]}>
        <div className={styles["per-owner-title-v2"]}>
          Obligations per Owner
        </div>
        <div>
          {filteredUsers &&
            Array.isArray(filteredUsers) &&
            filteredUsers?.length > 4 && (
              <Pagination
                overlayClassName="opo-pagination"
                current={currentPage}
                total={
                  filteredUsers && Array.isArray(filteredUsers)
                    ? filteredUsers?.length ?? 0
                    : 0
                }
                pageSize={itemsPerPage}
                showSizeChanger={false}
                onChange={onPageChange} // Handle page change
                style={{ display: "block" }}
                itemRender={(page, type, originalElement) => {
                  //custom render is used in order to be able to add ids on next and previous buttons for qa automation
                  if (type === "next") {
                    return currentPage !==
                      parseInt(
                        filteredUsers && Array.isArray(filteredUsers)
                          ? Math.ceil(filteredUsers.length / itemsPerPage)
                          : 0
                      ) ? (
                      <button
                        id="tasks-pagination-next"
                        className="ant-pagination-item-link"
                        type="button"
                        tabIndex="-1"
                      >
                        <span
                          role="img"
                          aria-label="right"
                          className="anticon anticon-right"
                        >
                          <svg
                            viewBox="64 64 896 896"
                            focusable="false"
                            data-icon="right"
                            width="1em"
                            height="1em"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"></path>
                          </svg>
                        </span>
                      </button>
                    ) : (
                      <></>
                    );
                  } else if (type === "prev") {
                    return currentPage !== 1 ? (
                      <button
                        id="tasks-pagination-prev"
                        type="button"
                        className="ant-pagination-item-link"
                        tabIndex="-1"
                      >
                        <span
                          role="img"
                          aria-label="left"
                          className="anticon anticon-left"
                        >
                          <svg
                            viewBox="64 64 896 896"
                            focusable="false"
                            data-icon="left"
                            width="1em"
                            height="1em"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"></path>
                          </svg>
                        </span>
                      </button>
                    ) : (
                      <></>
                    );
                  } else
                    return <button className="ant-pagination-tasks"></button>;
                  // return originalElement;
                }}
              />
            )}
        </div>
        <div className={styles["per-owner-searchbox-v2"]}>
          <Input
            prefix={<SearchOutlined />}
            placeholder="Search Owner"
            allowClear
            style={{ paddingTop: "0.438rem", paddingBottom: "0.438rem" }}
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)} // Update searchTerm based on user input
          />
        </div>
      </div>
      <div style={{ height: "fit-content", paddingBottom: "1.125rem" }}>
        {/* <div className="per-owner-title">Obligations per Owner</div> */}
        {renderFilteredUsers(currentItems)}
      </div>
    </div>
  );
};

export default TasksPerOwnerV2;
